export default __webpack_public_path__ + "static/media/lora_m.8b2f06e3.jpg";